import raf      from 'raf';
import Cookies  from 'js-cookie';

const selector = '[data-js-msg-global]';
const messaging = function(el, app) {
        "use strict";
        
        const $document = $(document);
        const $el = $(el);
        const waitDuration = 5000; // duration (in ms) that a non-persistent message is on screen for.
        const slideInDuration = 200; // time it takes to slide in
        const slideOutDuration = 500; // time it takes to slide out
        let   timer = {};
        let   isSilent = false;
        
        // are we re-initialising messages when it's already ready?
        if ($el.hasClass('Ge-Msg-Global--ready')) {
            return;
        }
        
        const init = function() {
            $el.addClass('Ge-Msg-Global--ready');
            registerEvents();
        };
        
        const registerEvents = function() {
            // app event to trigger a message to appear
            app.on('msgGlobal',function msgGlobalReceive (ev){
                const msg           = ev[0];
                const id            = ev[1];
                const type          = ev[2];
                const persistent    = ev[3];
                const noClose       = ev[4];
                set(msg,id,type,persistent,noClose);
            });
            // app event to trigger a message to disappear
            app.on('msgGlobalKill',function msgGlobalReceive (ev){
                const id            = ev[0];
                remove(ev,$('#msg-' + id),id);
            });
            // the ability to silence a message (so a mass of messages aren't shown/replaced - eg, during sliding the consumption range control)
            app.on('msgSilenceOn',silenceOn);
            app.on('msgSilenceOff',silenceOff);
            // the message close button
            $document.on('click','[data-js-msg-close]',remove);
        };

        // display message
        const set = function(msg,id,type,persistent,noClose) {
            
            if (!$el.length) {
                return;
            }
            
            if (isSilent) {
                return;
            }
            
            clearTimeout(timer[id]);

            let activeAlready = '';
            // if any messages with the same id are already active, replace the message without an animation
            if ($('#msg-' + id + '.Ge-Msg--active').length) {
                $('#msg-' + id).remove();
                activeAlready = ' Ge-Msg--active';
            // close any messages with the same ids, this time 
            } else if ($('#msg-' + id).length) {
                $('#msg-' + id).remove();
            }  

            const template = `
            <div id="msg-${id}" class="Ge-Msg Ge-Msg--${ type }${ activeAlready }" role="alert" aria-hidden="false">
                <div class="Ge-Msg-Inner">${ msg }</div>
                <button type="button" class="Ge-Msg-Button" data-js-msg-close>
                    <svg viewBox="0 0 512 512" class="Ge-Icon Ge-Msg-Button-Icon">
                        <use xlink:href="#icon_small-close"></use>
                    </svg>
                </button>
            </div>`;

            const $msg = $(template);

            // remove the close button if required
            if (noClose) {
                $msg.find('[data-js-msg-close]').remove();
            }
            
            $el.prepend($msg);

            // set the active state (after a frame) to trigger the animation in
            if (!activeAlready.length) {
                raf(function tick1() {
                    raf(function tick2() {
                        $('#msg-' + id).addClass('Ge-Msg--active');
                    });
                });
            }
            
            if (!persistent) {
                timer[id] = setTimeout(function messagingTimeout() {
                    remove(false,$msg,id);
                },waitDuration);
            }

        };
        
        // close a particular message
        const remove = function(ev,$el,id) {
            // clear any timeouts on non-persistent messages
            if (id) {
                clearTimeout(timer[id]);
            }
            // if we haven't been passed a message as a JQ element, use the one clicked
            if (!$el) {
                $el = $(this).closest('.Ge-Msg');
            }
            // close it
            $el.removeClass('Ge-Msg--active');

            const cookie = $el.attr('data-cookie-name');

            if( cookie ){
                Cookies.set(cookie, '1', { path: '/' });
            }
            // after transitions, remove it
            setTimeout(function() {
                $el.remove();
            },slideOutDuration);
        };
        
        // silence messages (so a mass of messages aren't shown/replaced - eg, during sliding the consumption range control)
        const silenceOn = function() {
            isSilent = true;
        };
        
        // unsilence messages
        const silenceOff = function() {
            isSilent = false;
        };

        return {
            init: init()
        };

};

messaging.selector = selector;

export default messaging;